import { AnalyticsEventKey, AnalyticsEvents } from "./types";

export abstract class AbstractAnalyticsClient {
  /**
   * A method to track an analytics even to the vendor analytics service.
   * This method should be implemented by the concrete analytics client.
   *
   * @abstract
   * @param event - the event name to track
   * @param properties - the properties to track with the event
   */
  protected abstract sendEvent<T extends AnalyticsEventKey>(event: T, properties?: Partial<AnalyticsEvents[T]>): void;
}
